var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKib(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / product-logo / 32x32px / kibana / color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.1847 0.6547 23.4987 0.6547 23.4987 16 0.1847 16"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-/-product-logo-/-32x32px-/-kibana-/-color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0.0004 L3,0.0004 L3,12.0004 C7.325,12.0004 11.385,13.1134 14.933,15.0474 L28,0.0004 Z",
    id: "Fill-1",
    fill: "#F04E98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3,12.0004 L3,28.7884 L14.933,15.0474 C11.385,13.1134 7.325,12.0004 3,12.0004",
    id: "Fill-3",
    fill: "#343741"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(4.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5107,0.6547 L1.2657,14.7567 L0.1847,16.0007 L23.4987,16.0007 C22.2197,9.6967 18.5607,4.2637 13.5107,0.6547",
    id: "Fill-5",
    fill: "#00BFB3",
    mask: "url(#mask-2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKib);
export default __webpack_public_path__ + "static/media/kib.58643598acc57db4da05719feaade959.svg";
export { ForwardRef as ReactComponent };